import { quoteStatuses } from './constants';

const getStatusColours = (status) => {
  switch (status) {
    case quoteStatuses.ACCEPTED:
    case quoteStatuses.PAID:
      return {
        color: '#10B981',
        bgcolor: 'rgba(16, 185, 129, 0.1)',
      };

    case quoteStatuses.UNPAID:
    case quoteStatuses.CANCELLED:
      return {
        color: '#EF4444',
        bgcolor: 'rgba(239, 68, 68, 0.1)',
      };
    case quoteStatuses.PENDING:
      return {
        color: '#F59E0B',
        bgcolor: 'rgba(245, 158, 11, 0.1)',
      };
    default:
      return {
        color: 'grey.500',
        bgcolor: 'grey.100',
      };
  }
};

export default getStatusColours;
